import ExamSectionTemplate from '@/pages/ExamSectionTemplate';

const faqs = [
  {
    question: "What is CBENA certification?",
    answer: "CBENA (Competency-Based Examination for Nursing in Aesthetic Practice) validates competency for registered nurses working in aesthetic medicine settings. It assesses procedure assistance protocols, emergency response capabilities, patient safety management, and clinical documentation skills."
  },
  {
    question: "Can nurses perform aesthetic procedures independently with CBENA?",
    answer: "CBENA certification validates competency for nursing support roles in aesthetic practice. Independent procedural practice must comply with national nursing regulations. Certification does not authorize independent medical procedures unless legally permitted in your jurisdiction."
  },
  {
    question: "What skills does CBENA assess?",
    answer: "CBENA assesses procedure assistance protocols, emergency response (including anaphylaxis and vascular occlusion protocols), patient safety management, medication handling, clinical documentation, and infection control in aesthetic practice settings."
  },
  {
    question: "What are the eligibility requirements for CBENA?",
    answer: "CBENA requires valid nursing registration, active Nursing Council registration, minimum 1 year post-registration clinical experience, evidence of training or experience in aesthetic practice settings, and professional references from supervising practitioners."
  },
  {
    question: "How does the examination work for nurses?",
    answer: "CBENA includes a Written Examination covering aesthetic nursing protocols, an OSCE focused on procedure assistance and emergency response drills, and a Supervisor-Verified Clinical Log demonstrating procedural assistance experience."
  },
  {
    question: "What career opportunities does CBENA provide?",
    answer: "CBENA-certified nurses can work in aesthetic clinics, medi-spas, cosmetic surgery centers, and dermatology practices as qualified aesthetic nursing professionals. The certification demonstrates validated competency to potential employers and patients."
  }
];

export default function AestheticNursingPage() {
  return (
    <ExamSectionTemplate
      sectionTitle="Section of Aesthetic Nursing"
      examCode="CBENA"
      ipcfBadge="Levels 4–5 Clinical Support Certification"
      examFullName="Competency-Based Examination for Nursing in Aesthetic Practice"
      testIdPrefix="cbena"
      fee="₹22,000"
      faqs={faqs}
      overview="CBENA validates competency for registered nurses working in aesthetic medicine settings. The examination assesses procedure assistance protocols, emergency response capabilities, patient safety management, and clinical documentation skills essential for nursing practice in aesthetic clinics."
      eligibility={[
        'Valid nursing registration in home jurisdiction',
        'Active Nursing Council registration',
        'Minimum 1 year post-registration clinical experience',
        'Evidence of training or experience in aesthetic practice settings',
        'Professional references from registered medical practitioners or nursing supervisors',
        'Current professional indemnity insurance',
      ]}
      stages={[
        { title: 'Written Examination', desc: 'Comprehensive written assessment covering aesthetic nursing protocols and patient safety.' },
        { title: 'OSCE (Procedure Assistance)', desc: 'Clinical examination stations focusing on procedure assistance and emergency response drills.' },
        { title: 'Supervisor-Verified Clinical Log', desc: 'Clinical log verified by supervising practitioner demonstrating procedural assistance experience.' },
      ]}
      coreDomains={[
        'Procedure Assistance Protocols',
        'Emergency Response',
        'Patient Safety Management',
        'Medication Handling',
        'Clinical Documentation',
        'Infection Control',
      ]}
      certificationValidity={[
        'Initial certification valid for 5 years from date of issue',
        'Certificate verifiable through IMCAC public verification portal',
        'Certification title: Board Certified in Aesthetic Clinical Nursing (IMCAC – CBENA)',
        'Certification subject to Nursing Council scope-of-practice regulations',
        'Annual declaration of regulatory compliance required',
      ]}
      recertificationPolicy={[
        'Recertification required every 5 years',
        'Minimum 15 CPD hours per year in aesthetic nursing practice',
        'Evidence of continued clinical practice under supervision',
        'Compliance with Nursing Council regulations',
        'Updated supervisor verification',
      ]}
      additionalDisclaimer="Independent procedural practice must comply with national nursing regulations. Certification does not authorize independent medical procedures unless legally permitted. Nurses must maintain active Nursing Council registration and practice within the scope defined by their jurisdiction's nursing regulations."
      disclaimer="Certification validates assessed competencies for nursing support in aesthetic practice and does not grant authority for independent medical procedures. Practice must remain within the legal scope defined by the candidate's Nursing Council registration."
      applyLink="/apply"
    />
  );
}
